module.exports = __webpack_public_path__ + "media/images/logos/outlook-06e6449354e85deb622121c3671f0d7f.svg";